import React from 'react';

const NotFound = () => (
  <>
    <h1>No Encontrado</h1>
    <h2>Regresa al Home</h2>
  </>
);

export default NotFound;
